import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function SakralniIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="SakralniIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M56.3,46.1v-9.2h9.5V24.4h-9.5V15H43.8v9.4h-9.5v12.5h9.5v9.2c-8,2.6-13.7,10.1-13.7,18.9
	c0,11,8.9,19.9,19.9,19.9S69.9,76,69.9,65C69.9,56.2,64.2,48.7,56.3,46.1z"/>
      <path fill="#3CAA78" d="M52.4,49.1v-16H62v-4.9h-9.5v-9.4h-4.9v9.4H38v4.9h9.5v16C39.8,50.3,33.8,57,33.8,65
	c0,8.9,7.2,16.1,16.1,16.1S66.1,73.9,66.1,65C66.1,56.9,60.2,50.2,52.4,49.1z"/>

    </svg>
  </SvgIcon>
}

export default SakralniIcon;
